import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./SettingsIndex'),
  loading: () => <Loading withContentWrapper />,
});

export const PlacementSettingsListPage = Loadable({
  loader: () => import('./PlacementSettingsListPage'),
  loading: () => <Loading withContentWrapper />,
});

export const PlacementSettingsFormPage = Loadable({
  loader: () => import('./PlacementSettingsFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const SharingSettingsFormPage = Loadable({
  loader: () => import('./SharingSettingsFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const LoginMethodsListPage = Loadable({
  loader: () => import('./LoginMethodsListPage'),
  loading: () => <Loading withContentWrapper />,
});

export const LoginMethodsSettingsFormPage = Loadable({
  loader: () => import('./LoginMethodsSettingsFormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const AdSettingsFormPage = Loadable({
  loader: () => import('./AdSettingsFormPage'),
  loading: () => <Loading withContentWrapper />,
});
